<template lang="pug">
  .contenedor-lista
    .title
      span Mis clases
    .body
      .information
        template(v-if="lista.length !== 0")
          .clase-item(
            v-for="(o, index) in lista"
            :key="index"
          )
            //- img.clase-imagen(v-if="o.imagen" :src="o.imagen" alt="Clase imagen")
            //- iframe(
            //-   width="300"
            //-   height="155"
            //-   src="https://www.youtube.com/embed/i8pMXOcK_bQ?si=sPVsWmZBsWvNlEbj?controls=0"
            //-   title="YouTube video player"
            //-   frameborder="0"
            //-   allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            //- )
            img.clase-imagen(v-if="o && o.idYT" :src="'https://img.youtube.com/vi/' + o.idYT + '/hqdefault.jpg'" :alt="o.titulo")
            .clase-detalles
              .clase-header
                span {{ o.titulo | truncateText(20) }}
                .descripcion(v-if="o.descripcion")
                  span {{ o.descripcion | truncateText(30) }}
              .clase-info
                span Duración: {{ o.duracion }}
            .clase-botones
              button.button.is-primary(v-if="o.estado === 0" @click="verClase(o.id, o.estado)") Ver clase
              button.button(v-else @click="verClase(o.id, o.estado)") Volver a ver
      div(v-if="!isLoading && lista.length === 0")
        .message.is-warning
          .message-body No hay clases registrados
      .is-loading(v-if="isLoading")
        .icon
          i.fa.fa-spinner.fa-spin
</template>


<script>
import { apiGet, notify } from '../util/general'

export default {
  name: 'cursos-virtuales-clase-lista',
  data () {
    return {
      lista              : [],  // Lista de cursos
      isLoading          : false
    }
  },
  computed : {
    showSidebarDesktop () {
      return this.$store.getters.showSidebarDesktop
    },
    idCurso () {
      return +this.$route.params.idCurso
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    fetch () {
      var vm = this
      vm.isLoading = true
      apiGet(vm, `/curso/virtual/alumno/lista/${vm.idCurso}/clase`, { modulo:'alumno' }, function (data) {
        vm.lista = data.lista
        console.log('data.lista >>>', data.lista)
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    verClase (id, estado) {
      var vm = this
      vm.$router.push(`/mis-cursos/${vm.idCurso}/clases/${id}`)
    },
    continuarCurso (id) {
    },
    volverIniciarCurso (id) {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .clase-item
    display: flex
    align-items: center
    padding: 15px
    border: 1px solid #eaeaea
    border-radius: 5px
    margin-bottom: 15px
    background-color: #fff
    max-width: 100%
    flex-wrap: wrap

  .clase-imagen
    width: 150px
    height: 100px
    object-fit: cover
    border-radius: 5px
    margin-right: 20px

  .clase-detalles
    flex: 1
    min-width: 200px
    .clase-header
      display: block
      span
        font-weight: bold
        display: block
    .descripcion
      margin-top: 5px
      color: #666
      font-size: 14px
      white-space: nowrap
      overflow: hidden
      text-overflow: ellipsis

    .clase-info
      margin-top: 10px
      span
        display: inline-block
        margin-right: 10px

  .clase-botones
    display: flex
    flex-direction: column
    justify-content: space-between
    align-items: center
    button
      margin-bottom: 5px
      min-width: 120px
  @media (max-width: 820px) and (min-width: 600px)
    .clase-item
      flex-direction: column
      align-items: center
      .clase-detalles
        width: 100%
        text-align: center
        margin-bottom: 10px
      .clase-botones
        flex-direction: row
        width: 100%  // Los botones ocuparán el ancho completo
        justify-content: center
        button
          flex: 1
          margin-right: 5px
        button:last-child
          margin-right: 0

  @media (max-width: 600px)
    .clase-item
      flex-direction: column
      align-items: flex-start
      .clase-imagen
        width: 100%
        height: auto
        margin-bottom: 10px
      .clase-detalles
        width: 100%

        .clase-info
          margin-top: 5px
          margin-bottom: 10px
      .clase-botones
        width: 100%
        button
          width: 100%
          margin-bottom: 5px



  .contenedor-interno
    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase

  th
    text-align center

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important


  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    min-width: 300px
    width: 100%;
    z-index: 70;
    top 0

  .position-relative
    position relative

  .codigo-empleado
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px

  .filtros-container
    padding-bottom 10px
    border-bottom 1px solid #ccc
    .title-filtro
      display flex
      text-align left
      padding-left 10px
      padding-bottom 10px
      margin-bottom 10px
      border-bottom 1px solid #ccc
      .text
        text-transform uppercase
        flex 1
      .caret
        cursor pointer

    .filtros
      margin-bottom 10px
      text-align left
      display flex
      align-items: flex-start;


      .filtro
        display inline-block
        border 1px solid #cccccc
        background-color #f9f9f9
        padding 5px
        margin 5px
        border-radius 3px
        flex 1
        max-width 25%
        .title-singular
          text-align left
          font-weight bold
          user-select: none
        .abierto-cerrado-container
          display flex
          .option
            padding 4px
            border 1px solid #565cde
            color #565cde
            cursor pointer
            transition all 0.3s ease
            height 31.5px

            &.selected
              background-color: #565cde;
              color: #fff;

        .list-container
          padding 0px 10px 0px 10px
          .option
            user-select: none
            cursor pointer
            &.selected
              color #565cde
              font-weight bold

  .boton-container
    button
      margin-left 5px



  .is-loading
    margin-top 10px

  .information
    padding-top 10px

  th
    vertical-align: middle;
  td
    vertical-align: middle;

  td
    .email
      font-size 12px
      color #9a9a9a

  .table
    font-size 13px

  .td-status
    width: 50px;

  .status
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .circle
      width: 25px;
      height: 25px;
      border-radius: 50%
      transition background ease-in .15s
      border 1px solid #d8d8d8
      background-color #23d160
      &.green
        background-color #23d160
      &.yellow
        background-color #ffdd57
      &.red
        background-color #ff0000
      &.white
        background-color #ffffff

  .status-container-filtro
    display flex
    justify-content center
    align-items center
    .status
      margin 5px
      cursor pointer
      .circle
        transition all ease-in .15s
        width: 30px;
        height: 30px;
      &.selected
        .circle
          border 2px solid #565cde
  .is-mobile
    display none
    .box
      position: relative;
    .status
      position:absolute;
      top: -3px
      right: 5px
      span {
        font-size: 10px;
        color #a5a5a5
        font-weight: bold;
      }
    .descripcion-tipo
      margin-bottom 5px
    .motivo
      word-wrap: break-word;
      background-color: #eff5fb;
      color: #296fa8;
      padding: 10px
    .botones
      display flex
      justify-content center
      margin-top 10px
      .button
        margin-right 5px
        &:last-child
          margin-right 0px
  .modal-sidebar-desktop-open
    width: calc(100% - 180px);
  @media (max-width 400px)
    .is-mobile
      display block

    .is-desktop
      display none
  @media (max-width: 820px)
    .modal-sidebar-desktop-open
      width: 100%;
</style>




// WEBPACK FOOTER //
// c_cursos_virtuales_clase_lista.vue?2ab9ec10